import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../../colors';

export const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  mainContent: ({withBanner, withJumpToDoc, evaluationsList}) => ({
    flexGrow: 1,
    backgroundColor: evaluationsList ? colors.neutral25 : colors.white,
    maxHeight: withBanner ? 'calc(100vh - 271px)' : 'calc(100vh - 210px)',
    overflowY: 'auto',
  }),
  nextApptRemainingTime: {
    color: colors.secondary500,
    fontWeight: 700
  },
  nextApptText: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    fontFamily: 'Manrope',
    color: colors.neutral900,
    margin: 0,
  },
  nextApptSubText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    fontFamily: 'Manrope',
    color: colors.neutral600,
    margin: 0,
  },
  evaluationTitle: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '24px',
    fontFamily: 'Manrope',
    color: colors.neutral900,
    margin: 0,
  },
  evaluationSubtitle: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    fontFamily: 'Manrope',
    color: colors.neutral600,
    margin: 0,
    textTransform: 'capitalize',
  },
  textLink: {
    padding: 0,
    height: '19px',
    fontSize: '14px',
    fontWeight: 600,
  },
  openScheduleButton: {
    height: '40px',
    fontSize: '14px',
    fontWeight: 600,
  },
  bookAppointmentBanner: {
    display: 'flex',
    padding: '24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderTop: `1px solid ${colors.neutral100}`,
    background: colors.white,
  },
  backToDocBanner: {
    display: 'flex',
    padding: '24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderTop: `1px solid ${colors.neutral100}`,
    background: colors.white,
    boxShadow: `0 -10px 20px 0 rgba(0, 0, 0, 0.04), 0 -2px 6px 0 rgba(0, 0, 0, 0.04), 0 0 1px 0 rgba(0, 0, 0, 0.04)`,
  },
  backToScheduleBanner: {
    display: 'flex',
    padding: '16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderTop: `1px solid ${colors.neutral100}`,
    background: colors.white,
    boxShadow: `0 -10px 20px 0 rgba(0, 0, 0, 0.04), 0 -2px 6px 0 rgba(0, 0, 0, 0.04), 0 0 1px 0 rgba(0, 0, 0, 0.04)`,
  },
  nextApptContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flex: '1 0 0'
  },
  nextApptTitle: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    margin: 0,
  },
  bannerText: {
    color: colors.neutral900,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    margin: 0,
  },
  nextApptTime: {
    color: colors.neutral600,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    margin: 0,
  },
  actionBtn: {
    padding: 0,
    borderRadius: '4px',
    minWidth: '40px !important',
    width: '40px !important',
    height: '40px !important',
    '& svg': {
      width: '16px',
      height: '16px',
    }
  },
  apptBtn: {
    width: '28px',
    height: '28px',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    }
  },
  danger: {
    color: colors.destructive600,
  },
});
